/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Model_Free_Plan_NoteInputs */



/**
* | output |
* | --- |
* | "Your plan runs Uno on the free shared model. Upgrade to choose a different model." |
*
* @param {Uno_Settings_Model_Free_Plan_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_model_free_plan_note = /** @type {((inputs?: Uno_Settings_Model_Free_Plan_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Model_Free_Plan_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Tarif führt Uno mit dem kostenlosen Standardmodell aus. Mit einem Upgrade können Sie ein anderes Modell wählen.")
	return /** @type {LocalizedString} */ ("Your plan runs Uno on the free shared model. Upgrade to choose a different model.")
});